import { render, staticRenderFns } from "./FiltroCotacoes.vue?vue&type=template&id=0652cc8a"
import script from "./FiltroCotacoes.vue?vue&type=script&lang=js"
export * from "./FiltroCotacoes.vue?vue&type=script&lang=js"
import style0 from "./FiltroCotacoes.vue?vue&type=style&index=0&id=0652cc8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports